import { render, staticRenderFns } from "./BellEmpty.vue?vue&type=template&id=7e895f14&"
import script from "./BellEmpty.vue?vue&type=script&lang=js&"
export * from "./BellEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports